
import PropTypes from 'prop-types';
import React from 'react';
import { tag } from '../../services/ATInternetService';
import SecondaryButton from '../buttons/secondarybutton/SecondaryButton';

const Header = ({ animatedLogo, className, children }) => {
	return <div className={`intro__header flex flex-row place-content-center bg-black w-screen text-white z-10 shadow-md ${className}`}>
		{!children && <SecondaryButton onClick={() => {
			window.open('https://hetklokhuis.nl/klokhuisscanner', '_self');
			tag.sendClick('header', {
				name: 'home-clicked',
			});
		}}>
			<img src={animatedLogo ? '/klokhuisscanner/logo128.gif?v1' : '/klokhuisscanner/logo192.png?v1'} alt="Logo" className="mr-2" />HET KLOKHUIS
		</SecondaryButton>}
		{children}
	</div>;
};

Header.propTypes = {
	animatedLogo: PropTypes.bool,
	children: PropTypes.any,
	className: PropTypes.string
}

Header.defaultProps = {
	animatedLogo: false,
	children: undefined,
	className: ''
}

export default Header;
